<mat-card class="coins-card coins-widget-card" appearance="outlined">
    <mat-card-header>
        <mat-card-title>
            <mat-icon class="coins-widget-main-icon" color="accent" fontIcon="paid"></mat-icon>
            Coins
        </mat-card-title>
        <mat-card-subtitle>Mitarbeiter-Kontostand</mat-card-subtitle>
    </mat-card-header>
    <mat-card-content>
        <div *ngIf="salesUser$ | async as salesUser" class="coins-widget-balance-container">
            <div class="coins-widget-balance-block coins-balance-total">
                <span class="coins-widget-label">Gesamt</span>
                <span class="coins-widget-value coins-widget-value-total">
                    <mat-icon class="coins-balance-icon" color="accent">savings</mat-icon>
                    <span class="coins-amount">{{ salesUser?.totalCoins ?? 0 }}</span>
                </span>
            </div>
            <div class="coins-widget-balance-block coins-balance-available">
                <span class="coins-widget-label">Verfügbar</span>
                <span class="coins-widget-value coins-widget-value-current">
                    <mat-icon class="coins-balance-icon" color="primary">account_balance_wallet</mat-icon>
                    <span class="coins-amount">{{ salesUser?.currentCoins || 0 }}</span>
                </span>
            </div>
        </div>
        <div *ngIf="!(salesUser$ | async)" class="coins-widget-error">
            <mat-icon class="icon-vert-align" color="warn">error</mat-icon>
            <span>Etwas ist schiefgelaufen</span>
        </div>
    </mat-card-content>
</mat-card>